import { useEffect } from "react";
import { useOverlayOrchestrator } from "../../createOverlayOrchestratorContext";
import { useOverlayStepsOrchestrator } from "../../useOverlayStepsOrchestrator";
const KEY = "adjust-banner";
export const useInitAdjustBanner = () => {
    const { dispatch } = useOverlayOrchestrator();
    const canProceed = useOverlayStepsOrchestrator(KEY);
    useEffect(() => {
        if (canProceed) {
            dispatch({ type: "INIT", payload: KEY });
        }
    }, [canProceed, dispatch]);
};
